import { PageBreak, Paragraph, TextRun, BorderStyle, HeadingLevel } from 'docx'
import SectionHeader from '../../SectionHeader'

const Chapter1Page = ({ reportData }) => {
  const { reprotDao, secondaryCompanyNickname } = reportData || {}
  const { companyName } = reprotDao || {}

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    SectionHeader({
      text: '第一章 本文件資訊之揭露與限制',
      size: 52,
      headingNumber: HeadingLevel.HEADING_1,
    }),
    new Paragraph({
      border: {
        top: {
          color: '#000000',
          style: BorderStyle.SINGLE,
          size: 25, // 控制橫線的粗細
        },
      },
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本文件包含',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '(即客戶)執行社交工程郵件演練所取得的相關資訊。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '建議採取特別保密措施以保護文件及其內容，且文件的所有副本均將交付予客戶。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text:
            '資訊安全評估是根據過去的經驗、目前可取得的資訊，' +
            '和已知的威脅，而這些因素可造成評估過程的不確定性。此外，' +
            '由於資訊安全是一個不斷發展和變化的領域，經',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text:
            '提供之社交工程郵件演練分析結果進行教育訓練後，' +
            '並不意味著惡意郵件之攻擊將會隨之停止，請客戶務必加強自身資安意識。' +
            '此外，此次社交工程所採用的分析結果報告是依據截至本文件產出前已知的惡意郵件攻擊技術。' +
            '隨著新的惡意郵件攻擊技術的持續發展，本文件中所指出的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '之社交工程的報告分析結果及為了降低該惡意郵件攻擊所需採取的補救措施可能隨之改變。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本文件由',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '製作，其內容之智慧財產權為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '所有，並僅提供',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '使用。本文件對任何第三方的揭露須遵守',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '和',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '間之合約及保密協定。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
  ]
}

export default Chapter1Page
